export const MyMinus = `<svg width="22" height="3" viewBox="0 0 22 3" fill="none" class="feather" style="stroke: auto" xmlns="http://www.w3.org/2000/svg">
<path d="M1.6665 1.5H20.3332" stroke="auto" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;